import { RatePlanTemplate, ParameterType } from './rate-plan-template.model';
import { IColumn } from '../../../shared-module/common/interfaces/IColumn.interface';

export class RatePlan {
    id: string;
    code: string;
    description: string;
    ratePlanTemplateId: string;
    marketId: number;
    ratePlanTemplate: RatePlanTemplate;
    snapshots: Array<Snapshot>;
    tags: Array<string>;

    constructor(ratePlanTemplate: RatePlanTemplate) {
        this.ratePlanTemplate = ratePlanTemplate;
        this.ratePlanTemplateId = ratePlanTemplate.id;
        this.snapshots = new Array<Snapshot>();
    }
}

export class Snapshot {
    effectiveAt: string;
    parameters: Array<Parameter>;
}

export class Parameter {
    code: string;
    inputValue: string;
    type: ParameterType;
    percentageOperation: PercentageOperation;
}

export enum PercentageOperation {
    Substract,
    Addition,
    Multiply
}

export class MarketRatePlan {
    ratePlanId: string;
    marketId: number;
    marketName: string;
    marketCurrency: string;
    ratePlan: RatePlan;
    planColumns?: Array<IColumn>;
    snapshotRows?: Array<ParameterRow>;

    constructor(marketId: number, ratePlan: RatePlan) {
        this.marketId = marketId;
        this.ratePlan = ratePlan;
        this.ratePlanId = this.ratePlan.id || '0';
        this.planColumns = new Array<IColumn>();;
        this.snapshotRows = new Array<ParameterRow>();
        this.ratePlan.marketId = marketId;
    }
}

export class ContractTerms {
    contractTermLength: number;
    minimumContractTermLength: number;

    constructor(contractTermLength: number = 0, minimumContractTermLength: number = 0) {
        this.contractTermLength = contractTermLength;
        this.minimumContractTermLength = minimumContractTermLength;
    }
}

export class ParameterRow {
    public id: string;
    public code: string;
    public description: string;
    public type: ParameterType;
}

export class ParameterCell {
    public inputValue: string;
    public percentageOperation?: PercentageOperation;

    constructor(value: string) {
        this.inputValue = value;
    }
}